(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagServiceItemTestController', OrderBagServiceItemTestController);

    OrderBagServiceItemTestController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'OrderBagServiceItem', 'ServiceItem', 'ServiceTimeSession', 'OrderBagServiceItemCustom', 'timeSession'];

    function OrderBagServiceItemTestController($timeout, $scope, $stateParams, entity, OrderBagServiceItem, ServiceItem, ServiceTimeSession, OrderBagServiceItemCustom, timeSession) {


        var vm = this;
        vm.orderBagServiceItem = entity;


        //vm.orderBagServiceItem = {status: 0,
        //    subtotalServicePrice: 1,
        //    subtotalOptionPrice: 1,
        //    subtotalVAT: 1,
        //    subtotalDiscount: 1,
        //    totalRowPrice: 1,
        //    id: null,
        //    orderBagServiceItemDtail :[],
        //    serviceItemId:1427
        //
        //};

        //
        // OrderBagServiceItemCustom.getOrderBagServiceItemWithEntities(3553).query(function(result){
        //
        //    vm.orderBagServiceItem = result;
        //
        //});

        vm.clear = clear;
        vm.save = save;
        //vm.serviceitems = ServiceItem.query();
        vm.serviceItemId = 1427;
        vm.selectedServiceTimeSession = timeSession;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            //$uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.orderBagServiceItem.id !== null) {
                OrderBagServiceItem.update(vm.orderBagServiceItem, onSaveSuccess, onSaveError);
            } else {
                OrderBagServiceItem.save(vm.orderBagServiceItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            //$scope.$emit('tikonApp:orderBagServiceItemUpdate', result);
            //$uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
